import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { Alert } from 'src/app/interfaces/alert';
import { ActivateNoEmailUserParams, AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';

@Component({
  selector: 'app-activate-no-email-user',
  templateUrl: './activate-no-email-user.component.html',
  styleUrls: ['./activate-no-email-user.component.scss']
})
export class ActivateNoEmailUserComponent implements OnInit {
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  public loading = false;
  public errorStrings = ErrorStrings;
  public alert: Alert = null;
  public model = {
    password: '',
    newEmailAddress: ''
  };

  private _currentNoEmailAddress: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authManager: AuthManagerService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    const queryParams = this._activatedRoute.snapshot.queryParams;

    if (!queryParams || (queryParams && !queryParams.currentEmailAddress)) {
      this.alert = {
        type: 'danger',
        message: 'An error has occurred, the URL is invalid! ' +
        'Please try to open the activate account email again, ' +
        'in case the issue still persist please feel free to contact us.'
      };
    } else {
      this._currentNoEmailAddress = queryParams.currentEmailAddress;
    }
  }

  public claimAccount() {
    this.closeAlert();
    this.loading = true;

    const activateNoEmailUserParams: ActivateNoEmailUserParams = {
      password: this.model.password,
      noEmailAddress: this._currentNoEmailAddress,
      newEmailAddress: this.model.newEmailAddress
    };

    this._authManager.activateNoEmailUser(activateNoEmailUserParams)
      .subscribe(() => {
        this.alert = {
          type: 'success',
          message: 'Your account was activated, you\'ll get redirected in a few seconds!'
        };

        setTimeout(() => {
          this._router.navigate(['/login']);
        }, 2000);
      },
      err => {
        if (err instanceof HttpErrorResponse && err.status === 400) {
            this.alert = {
              type: 'danger',
              message: 'Something went wrong! ' +
              'Please try to open the activate account email again or ' +
              'try to log in using the credentials that you provided. ' +
              'In case the issue still persist please feel free to contact us.'
            };
          } else if (err instanceof HttpErrorResponse && err.status === 409) {
            this.alert = {
              type: 'danger',
              message: 'The email address is already exists, please select another email address!'
            };
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
        }
      })
      .add(() => {
        this.loading = false;
      });
  }

  public closeAlert() {
    this.alert = null;
  }

}
